<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <el-button
            type="primary"
            style="margin-right: 10px; max-height: 36px"
            @click="QRcode"
          >授权</el-button>
          <el-button
            class="filter-item"
            type="primary"
            @click="allocationAccout(1)"
          >
            分配账户
          </el-button>
          <el-button
            class="filter-item"
            type="danger"
            @click="allocationAccout(2)"
          >
            取消分配
          </el-button>
        </div>
        <div class="searchContainer">
          <label class="inputLabel">账号ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">账号名称：</label>
          <el-input
            v-model="advertisersQuery.account_name"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label for="searchword">状态：</label>
          <el-select v-model="advertisersQuery.status" placeholder="请选择">
            <el-option
              v-for="item in accountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between"
      >
        <el-table-column prop="account_name" label="广告主名称" width="400" />
        <el-table-column prop="account_id" label="广告主账户id" width="170">
          <template scope="scope">
            <p class="overflow" :title="scope.row.account_id">
              {{ scope.row.account_id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="status_text" label="状态" />
        <el-table-column prop="account_type" label="账户身份id" />
        <el-table-column
          prop="account_type_name"
          label="账户身份名称"
          width="170"
        />
        <el-table-column prop="created_by" label="创建人id" />
        <el-table-column
          prop="admin_id"
          label="分配的管理员id"
          align="center"
        />

        <!-- <el-table-column
          prop="token"
          label="token"
          align="center"
        /> -->
        <el-table-column prop="fail_data" label="失败原因" />
        <el-table-column prop="fail_data" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 3" type="danger" size="mini" @click="deld(scope.row)">取消分配</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      :title="type == 1 ? '分配账户' : '取消分配'"
      :visible.sync="dialogAccout"
      width="50%"
      @close="close"
    >
      <dialogAccout ref="allocation" @callbackbacer="callbackbacer" />
    </el-dialog>
    <el-dialog title="二维码" :visible.sync="imgdialog" width="500px">
      <img :src="src" alt="">
    </el-dialog>
  </div>
</template>

<script>
import dialogAccout from './components/dialogAccout.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  wechat_auth_account,
  simulation_auth_wechat,
  wechat_auth_accountShare,
  wechat_auth_accountCancel
} from '@/api/customer.js'

export default {
  name: 'AccountList',
  components: {
    PaginationRight,
    dialogAccout
  },
  data() {
    return {
      imgdialog: false,
      src: '',
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        account_name: null,
        status: 1,
        page: null, // 当前页码
        pageSize: null // 显示数据条数
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      // 账号类型
      accountType: [
        {
          value: 1,
          label: '未分配'
        },
        {
          value: 2,
          label: '分配成功'
        },
        {
          value: 3,
          label: '分配失败'
        }
      ],
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false,
      dialogVisiblePull: false,
      moneyLoading: false, // 余额加载动画
      mantle: false,
      source: null,
      typeValue: '',
      activeItem: null,
      activeItemId: null,
      activeText: null,
      activeTextid: null,
      dialogVisibleadr: false,
      dialogAccout: false,
      type: ''
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    async callbackbacer(item) {
      console.log('item:', item.account_ids)
      if (this.type === 1) {
        try {
          await wechat_auth_accountShare(item)
          this.dialogAccout = false
          this.$message('分配微信授权账户成功')
        } catch (error) {
          console.log('error:', error)
        }
      } else {
        try {
          const obj = {
            account_id: item.account_ids.join(),
            admin_id: item.admin_id
          }
          const res = await wechat_auth_accountCancel(obj)
          this.dialogAccout = false
          this.$message(res.message)
        } catch (error) {
          console.log('error:', error)
        }
      }
    },
    close() {
      this.dialogAccout = false
      this.type = ''
    },
    allocationAccout(type) {
      this.type = type
      this.dialogAccout = true
      this.$nextTick(() => {
        this.$refs.allocation.sendr(type)
      })
    },
    async QRcode() {
      const res = await simulation_auth_wechat()
      console.log('res:', res)
      const that = this
      this.src = 'data:image/jpeg;base64,' + res.data.code
      this.imgdialog = true
      setTimeout(function() {
        that.imgdialog = false
        that.src = ''
      }, 30000) // 30秒
    },

    handleClose() {
      this.dialogVisiblePull = false
    },
    pullAll() {
      this.dialogVisiblePull = true
      this.$nextTick(() => {
        this.$refs.pull.sendr()
      })
    },

    getAdvertiserList() {
      this.loading = true
      wechat_auth_account(this.advertisersQuery).then((res) => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.total
        for (let i = 0; i < res.data.list.length; i++) {
          this.accountIdsQuery[i] = res.data.list[i].account_id
        }
        this.loading = false
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.pageSize = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {}
      this.getAdvertiserList()
    },

    reset(callback) {
      callback()
      this.source && this.source()
    },

    addadvr() {
      this.dialogVisibleadr = true
      this.$nextTick(() => {
        this.$refs.addadview.send()
      })
    },
    updata() {
      this.dialogVisibleadr = false
      this.getAdvertiserList()
    },
    async deld(val) {
      // console.log(val)
      // this.$confirm('确定要停止分配吗', '提示', {
      //   type: 'warning',
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消'
      // }).then(async() => {
      //   const obj = {
      //     account_id: val.account_id,
      //     admin_id: val.admin_id
      //   }
      //   const res = await wechat_auth_accountCancel(obj)
      //   this.$message(res.message)
      //   this.getAdvertiserList()
      // })
      const obj = {
        account_id: val.account_id,
        admin_id: val.admin_id
      }
      const res = await wechat_auth_accountCancel(obj)
      this.$message(res.message)
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 100px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
